import { rx, api } from '../../../api';
import { ofType, combineEpics } from 'redux-observable';
import { map as rxmap, mergeMap, takeUntil, exhaustMap } from 'rxjs/operators';
import { actions } from './actions';
import { errorMap } from '../../actions';

const addEpic = (action$) => {
	return action$.pipe(
		ofType(actions.add.request.type),
		mergeMap(action =>
			rx(api.mqtt.add, action.data).pipe(
				rxmap(operation => actions.load.request()),
				errorMap(actions.add.fail),
				takeUntil(action$.pipe(ofType(actions.add.cancel.type)))
			)
		)
	)
}

const loadEpic = (action$) => {
	return action$.pipe(
		ofType(actions.load.request.type),
		exhaustMap(action =>
			rx(api.mqtt.load).pipe(
				rxmap(operation => actions.load.success({ mqttClients: operation.response() })),
				errorMap(actions.load.fail),
				takeUntil(action$.pipe(ofType(actions.load.cancel.type)))
			)
		)
	)
}

const updateEpic = (action$) => {
	return action$.pipe(
		ofType(actions.update.request.type),
		mergeMap(action =>
			rx(api.mqtt.update, action.clientId, action.data).pipe(
				rxmap(operation => actions.load.request()),
				errorMap(actions.update.fail),
				takeUntil(action$.pipe(ofType(actions.update.cancel.type)))
			)
		)
	)
}

const removeEpic = (action$) => {
	return action$.pipe(
		ofType(actions.remove.request.type),
		mergeMap(action =>
			rx(api.mqtt.remove, action.clientId).pipe(
				rxmap(operation => actions.load.request()),
				errorMap(actions.remove.fail),
				takeUntil(action$.pipe(ofType(actions.remove.cancel.type)))
			)
		)
	)
}

const epic = combineEpics(addEpic, loadEpic, updateEpic, removeEpic);

export { epic };
